import { render, staticRenderFns } from "./AddShiftData.vue?vue&type=template&id=23935c26"
import script from "./AddShiftData.vue?vue&type=script&lang=js"
export * from "./AddShiftData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports